import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LeagueService {
    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) { }

    getById(id: string): any {
        return this.http.get(`${this.url}/league/${id}`);
    }

    getAllByOrganization(filter: any): any {
        return this.http.get(`${this.url}/leagues/organization`, { params: filter });
    }

    create(data: any): any {
        return this.http.post(`${this.url}/league/create`, data);
    }

    update(id: string, data: any): any {
        return this.http.post(`${this.url}/league/update/${id}`, data);
    }

    delete(data: any): any {
        return this.http.post(`${this.url}/league/delete`, data);
    }
}

